import React from 'react';
import { FormSelect, FormMultiSelect } from 'shared/formControls';
import { isNil } from 'lodash';
import { useGetEquipmentTypes } from 'src/fetch/equipmentType';
import { emptyArray } from 'src/shared/helpers/utils';

const CHASSIS_CATEGORY = 2;

const EquipmentTypeDropdown = ({ categoryFilter, data: propData, dataItemKey = 'id', textField = 'name', notChassis = false, showCategory = true, ...props }) => {
  let data = propData;
  if (!data) {
    const { data: newData = emptyArray } = useGetEquipmentTypes();
    data = newData;
  }

  let equipmentTypes = (props.equipmentTypes ?? data ?? []).map((e) => ({
    ...e,
    [dataItemKey]: e.id,
    [textField]: e.name,
    category: e.category,
    categoryDisplay: e.categoryDisplay,
    requiredDimensions: e.requiredDimensions,
  }));

  const SelectComponent = props.multiSelect ? FormMultiSelect : FormSelect;

  if (!isNil(categoryFilter)) {
    equipmentTypes = equipmentTypes.filter((e) => e.category === categoryFilter);
  }

  if (notChassis) {
    equipmentTypes = equipmentTypes.filter((e) => e.category !== CHASSIS_CATEGORY);
  }

  const itemRender = (li, itemProps) => {
    let category = itemProps?.dataItem?.categoryName || '';
    category = showCategory ? category : '';
    const itemChildren = (
      <span
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <div style={{
          flex: 1,
        }}
        >
          {li.props.children}
        </div>
        {
          category && (
            <div
              style={{
                color: 'gray',
                fontSize: '0.8rem',
              }}
            >
              {category}
            </div>
          )
        }
      </span>
    );

    return React.cloneElement(li, li.props, itemChildren);
  };

  return (
    <SelectComponent
      data={equipmentTypes}
      clearButton
      dataItemKey={dataItemKey}
      textField={textField}
      itemRender={itemRender}
      {...props}
    />
  );
};

export default EquipmentTypeDropdown;
